module.exports = __webpack_public_path__ + "img/logo_w.54b46f57.svg";